// extracted by mini-css-extract-plugin
export default {"container":"ProjectSidebar_container__i1xRf","open":"ProjectSidebar_open__ximxv","closed":"ProjectSidebar_closed__KADEb"};